export const scrollToAnchor = (anchorId: string, topOffset: number) => {
  const element = document.getElementById(anchorId);
  const scrollToPosition = element.offsetTop - topOffset;
  window.scrollTo({ top: scrollToPosition, behavior: "smooth" });
};
